import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const searchCities = async (q) => {
  const { data } = await client.get(`/cities/search`, { params: { q } });
  return data.results;
};

export const generateChart = async (payload) => {
  const { data } = await client.post(`/chart/generate`, payload);
  return data;
};

export const getChart = async (id) => {
  const { data } = await client.get(`/chart/${id}`);
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await client.post(`/contact`, payload);
  return data;
};

export const subscribeNewsletter = async (payload) => {
  const { data } = await client.post(`/newsletter`, payload);
  return data;
};
